import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { ReactNode } from 'react'

type PreLineTypographyProps = {
  children: ReactNode | string
  className?: string
}

const PreLineTypography = ({ className, ...props }: PreLineTypographyProps): JSX.Element => {
  return <p className={classNames('whitespace-pre-line', className)} {...props} />
}

export default PreLineTypography
